<template>
  <div>
    <el-input
      ref="input"
      v-model="val"
      type="text"
      :class="{'require':getRequire && isNull(), 'item': true}"
      size="small"
      placeholder="请输入内容"
      :disabled="disabled"
      show-word-limit
      :clearable="true"
      @input="input"
      @focus="togglePopover"
    />
    <!-- 开窗区域 -->
    <el-dialog
      :visible.sync="visible"
      placement="bottom"
      :width="popupWidth"
      class="ik-el-popover-warp"
    >
      <el-input
        ref="searchInput"
        v-model="val"
        type="text"
        :class="{'require':getRequire && isNull(), 'item': true}"
        size="small"
        placeholder="请输入内容"
        :disabled="disabled"
        show-word-limit
        :clearable="true"
        @input="input"
        @focus="togglePopover"
      />
      <!-- 数据表 -->
      <el-table
        ref="dataTable"
        v-loading="loading"
        highlight-current-row
        :data="tableData"
        :stripe="true"
        @row-click="rowClick"
        @current-change="handleCurrentChange"
      >
        <template
          v-for="(item, index) in filedList"
        >
          <ik-column-number
            v-if="item.type === 'number'"
            :key="index"
            :code="item.code"
            :name="item.name"
            :column-width="150"
            :edit="false"
          />
          <ik-column-select
            v-else-if="item.type === 'select'"
            :key="index"
            :code="item.code"
            :name="item.name"
            :column-width="150"
            key-field="key"
            value-field="value"
            :options="item.options"
            :edit="false"
          />
          <ik-column-text
            v-else
            :key="index"
            :code="item.code"
            :name="item.name"
            :column-width="150"
            :edit="false"
          />
        </template>
      </el-table>
      <!-- 分页器 -->
      <el-pagination
        layout="total, prev, pager, next"
        :page-count="pagination.pageCount"
        :page-size="pagination.pageSize"
        :total="pagination.totalCount"
        @current-change="currentChange"
        @prev-click="prevClick"
        @next-click="nextClick"
      />
    </el-dialog>
  </div>
</template>

<script>
import IkColumnText from '@/components/ik/table/ikColumn/IkColumnText'
import IkColumnNumber from '@/components/ik/table/ikColumn/IkColumnNumber'
import IkColumnSelect from '@/components/ik/table/ikColumn/IkColumnSelect'
import { verify } from '@/utils/ik/verify/verify.js'
import { findPopup } from '@/api/ik/data/dataApi'
export default {
  name: 'IkTableText',
  components: {
    IkColumnText,
    IkColumnNumber,
    IkColumnSelect
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    filedList: {
      type: Array,
      default: function() {
        return [
          { code: 'id', name: 'ID' },
          { code: 'code', name: '编码' },
          { code: 'name', name: '名称' }
        ]
      }
    },
    searchKey: {
      type: String,
      default: 'name'
    },
    searcher: {
      type: Object,
      default: function() {
        return {}
      }
    },
    pageSign: {
      type: Boolean,
      default: true
    },
    code: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    line: {
      type: Number,
      default: 0
    },
    value: {
      type: String,
      default: ''
    },
    edit: {
      type: Boolean,
      default: true
    },
    defaultValue: {
      type: String,
      default: ''
    },
    popupWidth: {
      type: String,
      default: '800'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    require: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      val: '',
      errorSign: false,
      message: '',
      visible: false,
      loading: false,
      tableData: [],
      selectedIndex: -1,
      pagination: {
        totalCount: 0,
        pageNo: 1,
        pageSize: 5,
        pageCount: 1
      }
    }
  },
  computed: {
    getRequire() {
      return this.require
    }
  },
  watch: {
    value: {
      handler(value, oldValue) {
        if (value !== null || value !== '' || this.val === undefined) {
          this.val = value
        } else {
          this.val = this.defaultValue
        }
        this.input(this.val)
      },
      immediate: true
    },
    visible(val) {
      if (val) {
        this.$nextTick(() => {
          this.addKeyboardListener()
          this.focusSearch()
        })
      } else {
        this.removeKeyboardListener()
        this.selectedIndex = -1
      }
    }
  },
  beforeDestroy() {
    this.removeKeyboardListener()
  },
  methods: {
    input(value, e) {
      this.message = verify(value, this.rules)
      if (this.message !== null) {
        this.errorSign = true
      } else {
        this.errorSign = false
      }
      if (this.getRequire && this.isNull()) {
        this.errorSign = true
        this.message = "必填项，不可为空"
      }
      this.find()
      this.$emit('onFieldChange', this.line, this.code, '', value, this.errorSign, this.message)
      this.$emit('input', value)
      this.$refs.input.blur()
    },
    isNull() {
      return this.val === '' || this.val === null || this.val === undefined
    },
    reset() {
      this.value = this.defaultValue
    },
    clean() {
      this.value = ''
    },
    togglePopover() {
      this.val = ""
      this.input("")
      this.pagination.pageNo = 1
      this.find()
      this.visible = true
    },
    closepop() {
      this.visible = false
    },
    addKeyboardListener() {
      document.addEventListener('keydown', this.handleKeydown)
    },
    removeKeyboardListener() {
      document.removeEventListener('keydown', this.handleKeydown)
    },
    handleKeydown(e) {
      if (!this.visible) return

      // Ctrl + F 聚焦搜索框
      if (e.ctrlKey && (e.key === 'f' || e.key === 'F')) {
        e.preventDefault()
        this.focusSearch()
        return
      }

      // Enter 确认选择（搜索框内也生效，因输入已实时搜索）
      if (e.key === 'Enter') {
        e.preventDefault()
        this.confirmSelection()
        return
      }

      // 上下选择行
      if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
        e.preventDefault()
        this.moveSelection(e.key === 'ArrowDown' ? 1 : -1)
        return
      }

      // 左右切换分页
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault()
        this.changePage(e.key === 'ArrowRight' ? 1 : -1)
        return
      }
    },
    focusSearch() {
      if (this.$refs.searchInput) {
        this.$refs.searchInput.focus()
        const inputEl = this.$refs.searchInput.$el.querySelector('input')
        if (inputEl) inputEl.select()
      }
    },
    moveSelection(direction) {
      if (this.tableData.length === 0) return
      const newIndex = this.selectedIndex + direction
      if (newIndex >= 0 && newIndex < this.tableData.length) {
        this.selectedIndex = newIndex
        this.$refs.dataTable.setCurrentRow(this.tableData[this.selectedIndex])
        this.scrollToRow(this.selectedIndex)
      }
    },
    scrollToRow(index) {
      this.$nextTick(() => {
        const rows = this.$el.querySelectorAll('.el-table__body-wrapper table tr')
        if (rows[index]) {
          rows[index].scrollIntoView({ block: 'nearest', behavior: 'smooth' })
        }
      })
    },
    confirmSelection() {
      if (this.selectedIndex >= 0 && this.selectedIndex < this.tableData.length) {
        this.rowClick(this.tableData[this.selectedIndex])
      }
    },
    changePage(direction) {
      const newPage = this.pagination.pageNo + direction
      if (newPage >= 1 && newPage <= this.pagination.pageCount) {
        this.pagination.pageNo = newPage
        this.find()
      }
    },
    handleCurrentChange(row) {
      if (row) {
        this.selectedIndex = this.tableData.indexOf(row)
      }
    },
    find() {
      this.loading = true
      this.searcher[this.searchKey] = this.val
      return findPopup(this.url, this.searcher, this.pageSign, this.pagination.pageSize, this.pagination.pageNo).then(response => {
        this.tableData = response.data.list
        this.pagination.totalCount = response.data.totalCount
        this.loading = false
        // 弹窗打开后默认选中第一行
        if (this.visible && this.tableData.length > 0) {
          this.selectedIndex = 0
          this.$nextTick(() => {
            if (this.$refs.dataTable) {
              this.$refs.dataTable.setCurrentRow(this.tableData[0])
            }
          })
        } else {
          this.selectedIndex = -1
        }
      })
    },
    rowClick(row) {
      this.selectedIndex = this.tableData.indexOf(row)
      this.visible = false
      this.$emit('onPopupClick', this.line, this.code, row)
    },
    currentChange(val) {
      this.pagination.pageNo = val
      this.find()
    },
    prevClick(val) {
      this.pagination.pageNo = val
      this.find()
    },
    nextClick(val) {
      this.pagination.pageNo = val
      this.find()
    }
  }
}
</script>
<style scoped>
::v-deep.require> .el-input__inner{
    border: red 1px solid;
}
.item{width:calc(100% - 30px)}
</style>
<style lang="scss" >
.el-form-item {
  margin-bottom: 12px;
  width: 100%;
}
.el-form-item__label {
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-form-item__content {
  width: calc(100% - 180px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
